import { render } from "./HeaderMain.component.vue?vue&type=template&id=358e5130&scoped=true&ts=true"
import script from "./HeaderMain.component.vue?vue&type=script&lang=ts"
export * from "./HeaderMain.component.vue?vue&type=script&lang=ts"

import "./HeaderMain.component.vue?vue&type=style&index=0&id=358e5130&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/MONICAS/FRONT/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-358e5130"]])

export default __exports__